import React from "react";
import { Instagram } from "lucide-react";
import { pushGtmEvent } from "@/lib/gtm";
import { DOCTOR, INSTAGRAM, WA_DISPLAY, waLink, LP_WA_MESSAGE } from "./lpData";

const LpFooter = () => (
  <footer className="bg-black text-white border-t border-white/10" data-testid="lp-footer">
    <div className="aevos-container py-12 grid gap-10 md:grid-cols-3">
      <div>
        <img
          src="/assets/aevos-horizontal-light-v2.svg"
          alt="AEVOS"
          className="h-9 w-auto"
          draggable={false}
        />
        <p className="mt-4 text-sm text-white/70 max-w-xs">
          AEVOS — Clínica de Performance &amp; Longevidade. Atuação em emagrecimento, saúde
          metabólica e Medicina Preventiva.
        </p>
      </div>

      <div>
        <h4 className="font-display text-sm tracking-[0.18em] uppercase !text-[#00C4FF] mb-4">Contato</h4>
        <ul className="space-y-3 text-sm text-white/80">
          <li>
            <a
              href={waLink(LP_WA_MESSAGE)}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#00C4FF]"
              data-testid="lp-footer-whatsapp"
              onClick={() => pushGtmEvent("whatsapp_click", { location: "lp_footer" })}
            >
              WhatsApp — {WA_DISPLAY}
            </a>
          </li>
          <li className="flex items-center gap-2">
            <Instagram size={16} className="text-[#00C4FF]" />
            <a
              href={`https://instagram.com/${INSTAGRAM}`}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#00C4FF]"
              data-testid="lp-footer-instagram"
            >
              @{INSTAGRAM}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-display text-sm tracking-[0.18em] uppercase !text-[#00C4FF] mb-4">
          Responsável Técnico
        </h4>
        <p className="text-sm text-white/80">
          <strong className="text-white">{DOCTOR.name}</strong>
          <br />
          {DOCTOR.specialty}
          <br />
          {DOCTOR.crm}
        </p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="aevos-container py-5 text-xs text-white/50">
        © {new Date().getFullYear()} AEVOS. Todos os direitos reservados.
      </div>
    </div>
  </footer>
);

export default LpFooter;
